import { useScrollVisible } from "./useScrollVisible";

const TREATMENTS = [
  {
    num: "01",
    title: "Lernen und Gesundheit",
    desc: "Konzentration, Merkfähigkeit und Lernfreude stärken – für Schule, Ausbildung und Alltag.",
  },
  {
    num: "02",
    title: "Blockaden lösen",
    desc: "Festgefahrene Muster erkennen und sanft auflösen, damit Energie wieder frei fließen kann.",
  },
  {
    num: "03",
    title: "Potential entfalten",
    desc: "Eigene Stärken sichtbar machen und Schritt für Schritt in die eigene Mitte finden.",
  },
  {
    num: "04",
    title: "Negative Glaubenssätze löschen",
    desc: "Hinderliche innere Überzeugungen aufspüren und durch stärkende ersetzen.",
  },
  {
    num: "05",
    title: "Ängste und Stress abbauen",
    desc: "Anspannung lösen, zur Ruhe kommen und mehr Gelassenheit im Alltag gewinnen.",
  },
];

export function Treatments() {
  const { ref, visible } = useScrollVisible(0.1);

  return (
    <section id="behandlungen" className="relative py-24 md:py-32 bg-sand-50 border-t border-stone-800/5">
      <div ref={ref} className="max-w-6xl mx-auto px-5 lg:px-10">
        <div
          className={`flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-sage-700" />
              <span className="text-sage-700 text-[11px] tracking-[0.35em] uppercase font-medium">
                Angebot
              </span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl text-stone-900 leading-[1.08] tracking-tight font-semibold max-w-xl">
              Wobei ich dich begleite.
            </h2>
          </div>
          <p className="text-stone-700/80 text-sm font-light max-w-xs">
            Jede Sitzung findet in entspannter, vertraulicher Atmosphäre statt – individuell auf dich abgestimmt.
          </p>
        </div>

        <div className="border-t border-stone-800/10">
          {TREATMENTS.map((t, i) => (
            <article
              key={t.title}
              className={`group grid grid-cols-[44px_1fr] md:grid-cols-[60px_1fr] gap-4 md:gap-8 items-baseline py-7 md:py-8 border-b border-stone-800/10 hover:bg-sand-100/60 transition-colors duration-300 px-2 -mx-2 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
              }`}
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <span className="font-display text-sm text-terra-500 font-medium tracking-wider">{t.num}</span>
              <div>
                <h3 className="font-display text-2xl md:text-3xl text-stone-900 font-medium tracking-tight mb-2 group-hover:text-sage-700 transition-colors duration-300">{t.title}</h3>
                <p className="text-stone-700 text-sm leading-relaxed font-light max-w-md">{t.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
